const translations = {
  "en": {
    "Current": "Current",
    "Entry": "Entry",
    "Potential": "Potential",
    "Stop Loss": "Stop Loss"
  },
  "zh-tw": {
    "Current": "目前",
    "Entry": "買入價",
    "Potential": "潛在漲幅",
    "Stop Loss": "停損位"
  }
};

export default translations;
